var path = '/templates/zenclerk_s/directives/dashboard/widget.html';
var html = "<div class=\"panel widget\"><div class=\"panel-header widget-header\" ng-transclude=title></div><div class=\"panel-content widget-content\" ng-transclude=content></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/directives/dashboard/widget.html
// module id = 1340
// module chunks = 0